import { render, staticRenderFns } from "./SelectTaskPosition.component.vue?vue&type=template&id=a098e64a&scoped=true&"
import script from "./SelectTaskPosition.component.vue?vue&type=script&lang=js&"
export * from "./SelectTaskPosition.component.vue?vue&type=script&lang=js&"
import style0 from "./SelectTaskPosition.component.vue?vue&type=style&index=0&id=a098e64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a098e64a",
  null
  
)

export default component.exports